import React, { useState, useEffect } from 'react';
import useEmblaCarousel from 'embla-carousel-react';
import Autoplay from 'embla-carousel-autoplay';
import './video.css'; // Add custom styles for the carousel

const slides = [
  { src: process.env.PUBLIC_URL + '/videos/oignon.mp4', title: 'le garcon oignon/animation/2025', url: "https://youtu.be/yKNas4OvNgI" },
  { src: process.env.PUBLIC_URL + '/videos/babyloveme.mp4', title: 'Baby Love Me/animation/2026', url: "https://www.tiktok.com/@gaajuto/video/7598863762761731350" },
  { src: process.env.PUBLIC_URL + '/videos/leclub.mp4', title: 'Generique "Le Club" RTS/animation/2026', url: "https://www.youtube.com/watch?v=m7pMyWg_-48" },
  { src: process.env.PUBLIC_URL + '/videos/chatskate.mp4', title: 'Le chat skateur/animation/2026', url: "https://www.tiktok.com/@gaajuto/video/7599215405219204355" },
  { src: process.env.PUBLIC_URL + '/videos/gagner.mp4', title: "gagner c'est bien perdre ca craint/animation/2025", url: "https://youtu.be/Ac3oQSA2Gv0" },
  { src: process.env.PUBLIC_URL + '/videos/gentil.mp4', title: 'Studio Gentil/animation/2023', url: "https://www.instagram.com/p/Cg4jiuwjgiQ/" },
  { src: process.env.PUBLIC_URL + '/videos/nouvellecouleur.mp4', title: 'nouvelle couleur/clip/2025', url: "https://youtu.be/2PM2P4K1qBk?list=RD2PM2P4K1qBk" },
];

const VideoCarousel = ({ setEmblaApi }: { setEmblaApi: (api: typeof useEmblaCarousel) => void }) => {
  const [emblaRef, emblaApi] = useEmblaCarousel(
    {
      loop: true,
      align: 'center',
      containScroll: 'trimSnaps',
    },
    [Autoplay({ delay: 4000, stopOnMouseEnter: true, stopOnInteraction: false })]
  );

  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    if (!emblaApi || !setEmblaApi) return;

    setEmblaApi(emblaApi);

    const updateSlide = () => setCurrentSlide(emblaApi.selectedScrollSnap());
    emblaApi.on('select', updateSlide);
    updateSlide(); // initialize
  }, [emblaApi, setEmblaApi]);

  return (
    <>
      <div className="embla" ref={emblaRef}>
        <div className="embla__container">
          {slides.map((slide, index) => (
            <div
              className="embla__slide"
              key={index}
            >
              <a href={slide.url} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
                <video
                  src={slide.src}
                  muted
                  loop
                  playsInline
                  autoPlay
                  preload="metadata"
                />
              </a>
            </div>
          ))}
        </div>
      </div>

      {/* le titre sur mobile */}
      <div className="carousel-info-video">
        <span className="carousel-title">{slides[currentSlide].title}</span>
      </div>
    </>
  );
};

export default VideoCarousel;